export const generateFile = async (img, fields, fileName) => {
    const fileToFetch = img.includes('iem-preview-cpb') ? `${img}?no-cache` : img;

    const response = await fetch(fileToFetch, {
        method: 'GET',
        headers: {
            'Content-Type': 'application/json'
        }
    }).then((res) => {
        return res.blob();
    });
    const blob = await response;
    const fileFormat = await blob.type.split('/')[1];
    let file = new File([blob], `${fileName}.${fileFormat}`, {
        type: blob.type
    });
    const data = {
        bucket: 'iem-preview-cpb',
        ...fields,
        'Content-Type': blob.type,
        file: file
    };
    const formData = new FormData();
    for (const value in data) {
        formData.append(value, data[value]);
    }
    return formData;
};
